import { toast as sonnerToast } from 'sonner';

// Toast utility for notifications using Sonner
interface ToastOptions {
  title: string;
  description: string;
  variant?: 'default' | 'destructive';
}

export const toast = ({ title, description, variant = 'default' }: ToastOptions) => {
  const message = `${title}: ${description}`;
  
  if (variant === 'destructive') {
    sonnerToast.error(message);
  } else {
    sonnerToast.success(message);
  }
};

// Export additional toast functions for direct use
export const toastSuccess = (message: string) => sonnerToast.success(message);
export const toastError = (message: string) => sonnerToast.error(message);
export const toastInfo = (message: string) => sonnerToast.info(message);
export const toastWarning = (message: string) => sonnerToast.warning(message);
export const toastLoading = (message: string) => sonnerToast.loading(message);

// Promise toast for async operations
export const toastPromise = <T>(
  promise: Promise<T>,
  {
    loading,
    success,
    error,
  }: {
    loading: string;
    success: string | ((data: T) => string);
    error: string | ((error: any) => string);
  }
) => sonnerToast.promise(promise, { loading, success, error });
